import { IStudentProfile } from '@models/IProfile'
import { getStudentHomeWorkdFinished } from '@servise/homeworkAPI'
import { getStudentWordsLearned } from '@servise/vocabulary'
import React from 'react'
import { useEffect, useState } from 'react'
import { getStudentCurrentCourse } from '@servise'
import * as Styled from './student-card.styles'
import { fetchStudentPayments } from '@servise/profileAPI'

const Progress = ({ studentData }: { studentData: IStudentProfile }) => {
  const [learnedWordsCount, setLearnedWordsCount] = useState(0)
  const [finishedHomeWorkCount, setFinishedHomeWorkCount] = useState(0)
  const [passedLessons, setPassedLessons] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const [currentCourse, setCurrentCourse] = useState(null)
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true)

        const [words, payments, finishedHomeWorkCount, currenCourse] = await Promise.all([
          getStudentWordsLearned(studentData.id),
          fetchStudentPayments(studentData.id),
          getStudentHomeWorkdFinished(studentData.id, studentData.teachers || []),
          studentData.currentCourseId
            ? getStudentCurrentCourse({
                studentId: studentData.id,
                courseId: studentData.currentCourseId,
              })
            : Promise.resolve(null),
        ])

        setCurrentCourse(currenCourse)
        setLearnedWordsCount(words.length)
        setFinishedHomeWorkCount(finishedHomeWorkCount)
        const passedLessons = payments.filter(payment => payment.package === -1).length
        setPassedLessons(passedLessons)
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [studentData])

  return (
    <Styled.ProsgressContainter>
      <Styled.StudentCardHeader>Progress</Styled.StudentCardHeader>
      <Styled.Div className="progress-content">
        {isLoading ? (
          <Styled.ToCenter>No classes</Styled.ToCenter>
        ) : (
          <>
            <Styled.ProgressRow>
              {currentCourse ? (
                <Styled.CourseBlock style={{ alignItems: 'flex-start' }}>
                  <span>Current course:</span>
                  <Styled.CourseLabel
                    style={{
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      display: 'inline-block',
                      overflow: 'hidden',
                      maxWidth: 250,
                    }}
                  >
                    {currentCourse.name}
                  </Styled.CourseLabel>
                </Styled.CourseBlock>
              ) : null}
            </Styled.ProgressRow>
            <Styled.ProgressBlock>
              <Styled.ProgressRow>
                <span>Completed lessons:</span>
                <Styled.ProgressLabel>{passedLessons}</Styled.ProgressLabel>
              </Styled.ProgressRow>
              <Styled.ProgressRow>
                <span>Completed homework:</span>
                <Styled.ProgressLabel>{finishedHomeWorkCount}</Styled.ProgressLabel>
              </Styled.ProgressRow>

              <Styled.ProgressRow>
                <span>Learnt words:</span>
                <Styled.ProgressLabel>{learnedWordsCount}</Styled.ProgressLabel>
              </Styled.ProgressRow>
            </Styled.ProgressBlock>
          </>
        )}
      </Styled.Div>
    </Styled.ProsgressContainter>
  )
}

export default Progress
